import React, {useEffect, useState} from 'react';
import {useOutletContext, useParams} from "react-router-dom";
import {getModuleInfo} from "../../services/CourseRepository";
import {useError} from "../../hooks/useError";
import {TopBarNavigationCourse} from "../../components/navigation/TopBarNavigationCourse";
import {ChapterNavigationBar} from "../../components/navigation/ChapterNavigationBar";
import {FaBookOpen} from "react-icons/fa";
import {CourseGoalsIntegrated} from "./CourseGoalsIntegrated";
import {GiChemicalDrop, GiCrystalGrowth, GiCutLemon, GiMeltingIceCube, GiMineExplosion} from "react-icons/gi";
import {SiMoleculer} from "react-icons/si";
import {MdOutlineWaterDrop} from "react-icons/md";
import {IoEarth} from "react-icons/io5";
import ComplexParser from "./ComplexParser";
import {convertIcon} from "../../utils/DynamicContentUtils";
import {ChapterTopicBox} from "./ChapterTopicBox";
import {
    boxColors,
    experiment_palette,
    features_palette,
    space_palette,
    subtle_palette
} from "../../components/color/Palettes";

export function ModuleLandingPage() {

    const params = useParams();
    const {setErrorMessage} = useError();
    const [moduleInfo, setModuleInfo] = useState(null);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const {courseId} = useOutletContext();

    useEffect(() => {
        getModuleInfo(courseId, params.moduleName, setErrorMessage).then(response => {
            setModuleInfo(response)
        })
    }, [params.moduleName]);

    if (moduleInfo == null) {
        return null;
    }
    return (
        <div>
            <div>
                <div className={"bg-neutral-3 "}>
                    <TopBarNavigationCourse crumbs={moduleInfo.crumbs}
                                            clickCallback={() => {
                                                setToggleSidebar(!toggleSidebar)
                                            }}
                                            nextChapter={moduleInfo.nextChapter} prevChapter={moduleInfo.prevChapter}
                                            courseName={moduleInfo.courseId}
                                            productId={moduleInfo.productId}
                                            disableAIBtn={true}
                    />
                    <div className={"row "}>
                        <div
                            className={"col-3 p-0 bg-white border-end sticky-sidebar  " + (!toggleSidebar ? "d-none" : "")}>
                            <ChapterNavigationBar courseId={moduleInfo.courseId} initSelectedModule={moduleInfo.module}
                                                  preview={false}/>
                        </div>

                        <div className={"col bg-white"}>
                            <div className={"container pt-5"} style={{maxWidth: "960px"}}>
                                <div className={"p-3 ps-5 py-3 text-white rounded mb-3 module-hero"}>
                                    <div className={"row"}>
                                        <div className={"col d-flex flex-column justify-content-center"}>
                                            <span className={"badge chapter-badge py-3 rounded-5 "}>
                                                Kapittel {moduleInfo.module.sortOrder}
                                            </span>
                                            <h1 className={"mb-2"}>{moduleInfo.module.title}</h1>
                                        </div>
                                        <div className={"col-3"}>
                                            {convertIcon(moduleInfo.module.icon, 128)}
                                        </div>
                                    </div>
                                </div>



                                <div className={"mb-5 pt-3"}>
                                    {
                                        moduleInfo.module.info != null ?
                                            (
                                                <>
                                                    {
                                                        moduleInfo.module.info.comment != null && moduleInfo.module.info.comment != "" ?
                                                            <p className={"mb-2 pt-4"}>
                                                                <strong>Kommentar: </strong>
                                                                {moduleInfo.module.info.comment}
                                                            </p> : null
                                                    }

                                                    {
                                                        moduleInfo.module.info.info.map((info, idx) => (
                                                            <ChapterTopicBox topic={info}
                                                                             className={"mb-3"}
                                                                             color={boxColors[idx]}
                                                                             initToggle={idx === 0}/>))
                                                    }
                                                </>
                                            )

                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );


}